<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="flex flex-wrap field-value">
      <div
        v-if="isLoading"
        class="w-full mt-2 flex justify-center"
      >
        <BaseSpinner />
      </div>
      <ul
       v-else-if="courses.length"
       class="list-disc list-inside ml-4"
      >
        <li
          v-for="(course, index) in courses"
          :key="course ? course.courseId: 'courseNotFound' + index"
        >
          <NuxtLink
            :to="getCourseUrl(course)"
            :title="generateCourseLabel(course)"
            class="mb-1 color-theme-light hover:color-theme-base underline transition-all duration-300 ease-in-out"
          >
            {{ generateCourseLabel(course) }}
          </NuxtLink>
        </li>
      </ul>
      <span v-else>{{emptyValuePlaceholder}}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CoursesService from '@/services/courses'
import useCourses from '@/composables/useCourses'
import { generateCourseLabel } from '@/utils/dataLabels'

export default {
  props: {
    value: {
      type: [String, Array],
      default: () => [],
    },
    question: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      courses: [],
      isLoading: false,
    }
  },
  setup(props, { root }) {
    const { getCourseUrl } = useCourses(root)

    return { getCourseUrl, generateCourseLabel }
  },
  computed: {
    ...mapGetters('settings', ['enableFetchingRequisitesWithLatestRevisions']),
    emptyValuePlaceholder() {
      return this.question?.config?.emptyValuePlaceholder || '-'
    },
  },
  methods: {
    async fetchCourses() {
      const courseIds = Array.isArray(this.value) ? this.value : [this.value]
      if (courseIds.length === 0) {
        this.courses = []
        return
      }
      this.isLoading = true
      const api = new CoursesService(this.$axios, this.$store)
      this.courses = await Promise.all(
        courseIds.map((courseGroupId) => api.getCourse(courseGroupId))
      )
      if (this.enableFetchingRequisitesWithLatestRevisions) {
        this.courses = this.courses.filter(Boolean)
      }
      this.isLoading = false
    }
  },
  async mounted() {
    await this.fetchCourses()
  },
  watch: {
    value: {
      handler: 'fetchCourses',
      immediate: false
    }
  }
}
</script>
